import React, { Component } from 'react'
import ParadigmaModal from '../../../components/ParadigmaModal/ParadigmaModal';
import api from "../../../api";
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js"
import moment from 'moment';
export default class PosponerVencLinkInforme extends Component {
    constructor(props){
        super(props);
        this.handleDateChange = this.handleDateChange.bind(this)
        this.state = {
            date: ''
        }
    }

    handleDateChange = date => {
        this.setState(
            () => ({ date }),
            this.onChange
        );
    }

    setData = (data) => {
        this.setState({
            ...data,
            fechaVencimiento: moment(data.fechaVencimiento)
         });
    }


    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.informes.posponervencimiento}
                postUrl={api.proyectos.informes.posponervencimiento}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"Fecha de vencimiento pospuesta."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"No se ha generado el informe."}
                title={"Posponer fecha de vencimiento del informe"}
                buttonTitle={"Posponer fecha de vencimiento"}
                buttonIcon={"fa fa-calendar fa-lg"}

                saveButton={true}
                closeButton={true}
                buttonClass={"btn-success btn-next"}
                onGotData={(data) => this.setData(data)}
                onPreSubmit={() => ({fechaVencimiento: this.state.fechaVencimiento})}
                className={"ui-modal-dialog ui-modal-md"}
                >

                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Vencimiento del informe</p>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>Vencimiento</label>
                                <ParadigmaDatePicker
                                    value={this.state.fechaVencimiento}
                                    onChange={(fechaVencimiento) => this.setState({fechaVencimiento})}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento4/PosponerVencMail.js